import { AttackPattern, PatternState } from '../../AttackPattern.js';

/**
 * Echo Orbit — the ghost's hostile mirror of Orbit Ward (Echo Duel, see
 * data/echoBoss.js): a rotating twin-arm spiral emitter centered on the
 * ghost. Reads as an orbiting shard ring turned outward; the spiral's spin
 * speed scales with the recorded weapon's level.
 */
export class EchoOrbit extends AttackPattern {
  constructor({ config }) {
    super({ name: 'Echo Orbit', telegraphDuration: 0.6, activeDuration: 2.2, minPhase: 0 });
    this.config = config;
  }

  onBegin() {
    this._angle = Math.random() * Math.PI * 2;
    this._fireTimer = 0;
  }

  onActiveTick(dt, boss, _player, pool) {
    this._angle += (1.8 + (this.config.level ?? 1) * 0.15) * dt;
    this._fireTimer -= dt;
    if (this._fireTimer > 0) return;
    this._fireTimer = 0.09;

    const speed = this.config.speed ?? 70;
    for (const armOffset of [0, Math.PI]) {
      const angle = this._angle + armOffset;
      pool.fire({
        x: boss.x,
        y: boss.y,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed,
        radius: 2.5,
        damage: this.config.damage,
        color: '#c9a8ff',
        lifetime: 4.5,
      });
    }
  }

  getVisual(boss) {
    if (this.state !== PatternState.TELEGRAPH) return null;
    return { kind: 'ringPulse', x: boss.x, y: boss.y, t: 1 - this._timer / this.telegraphDuration };
  }
}
